import axios from "axios";

export const createTrainingModule = async (username, trainingModuleVO) => {
    try {
        const {data} = await axios.post("/api/trainingModule/create",{username, trainingModuleVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllTrainingModules = async (username) => {
    try {
        const {data} = await axios.get("/api/trainingModule/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateTrainingModule = async (username, trainingModuleVO) => {
    try {
        const {data} = await axios.put("/api/trainingModule/update", {username, trainingModuleVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteTrainingModule = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/trainingModule/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
